<template>
  <div class="form_container">
    <form @submit.prevent="submitForm">
      <div class="auth-form-container">
        <h2>Login</h2>
        <div class="block-input">
          <InputCustom
            v-model.trim="email"
            :type="'text'"
            :className="{
              // error: email && !isEmailValid,
              required: isEmailValid === false,
              valid: isEmailValid,
            }"
            :placeholder="'Enter your email'"
          />
          <!-- @input="validateEmail" -->
          <InputCustom
            v-model.trim="password"
            :type="'password'"
            :className="{
              // error: password && !isPasswordValid,
              required: isPasswordValid === false,
              valid: isPasswordValid,
            }"
            :placeholder="'Enter your password'"
          />
        </div>
        <!-- @input="validatePassword" -->
        <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
        <div class="col-12 py-2">
          <ButtonWithLoading
            title="Send"
            :isLoading="isLoading"
            type="submit"
            class="w-100"
          />
        </div>
      </div>
    </form>
    <div class="d-flex justify-content-between mt-3 align-items-center">
      <button @click="forgetPassword" class="switch-button">
        Forgot password?
      </button>
      <div class="d-flex align-items-center">
        <span class="switch-text">Don't have an account?</span>
        <button class="switch-button" @click="switchToRegister">
          Register
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/vuex/store.js";
import ButtonWithLoading from "../ButtonWithLoading.vue";
import InputCustom from "../InputCustom.vue";

export default {
  name: "LoginForm",
  components: {
    ButtonWithLoading,
    InputCustom,
  },
  data() {
    return {
      email: "",
      password: "",
      isEmailValid: false,
      isPasswordValid: false,
      loading: false,
    };
  },

  methods: {
    forgetPassword() {
      this.$emit("forgetPassword");
    },
    switchToRegister() {
      this.$emit("switchMode");
    },
    isValid() {
      return this.isEmailValid && this.isPasswordValid;
    },
    validateEmail() {
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.isEmailValid = emailRegex.test(this.email);
    },
    validatePassword() {
      const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\W]{8,}$/;
      this.isPasswordValid = passwordRegex.test(this.password);

      // if (!this.isPasswordValid) {
      //   clearTimeout(this.passwordValidationTimeout);
      //   this.passwordValidationTimeout = setTimeout(() => {
      //     this.debouncedNotify();
      //   }, 1000);
      // } else {
      //   clearTimeout(this.passwordValidationTimeout);
      // }
    },
    submitForm() {
      if (this.isValid()) {
        const data = {
          email: this.email.toLowerCase(),
          password: this.password,
        };
        store.dispatch("login", data);
      } else {
        this.$notifications.notify({
          message: `<span>Password must contains at least: 8 characters, 1 number, 1 lowercase and 1 uppercase letters and 1 special symbol</span>`,
          icon: "nc-icon nc-simple-remove",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      }
    },
    // debouncedNotify: _.debounce(function () {
    //   this.$notifications.notify({
    //     message: `<span>Password must contains at least: 8 characters, 1 number, 1 lowercase and 1 uppercase letters and 1 special symbol</span>`,
    //     icon: "nc-icon nc-simple-remove",
    //     horizontalAlign: "right",
    //     verticalAlign: "top",
    //     type: "danger",
    //   });
    // }, 0),
  },
  computed: {
    isLoading() {
      return store.state.auth.isLoading;
    },
    errorMessage() {
      return store.state.auth.errorAuth;
    },
  },
  watch: {
    email() {
      this.validateEmail();
    },
    password() {
      this.validatePassword();
    },
  },
};
</script>

<style scoped lang="scss"></style>
